// extracted by mini-css-extract-plugin
export default {"wraperNavigation":"styles_wraperNavigation__tQt7r","active":"styles_active__epSJg"};